import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import {entityOaid} from "../../util/util";

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      tableColumn: [],
      oaid:null,
      loading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pagerCount:3,
        align: 'center',
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true
      },
      data: [],
      exportConfig: {},
      relation_type: "全部",
    }
  },
  methods: {
    openDataExport () {
      let s = "TOP供应链关联度"
        this.$refs.xTable_data.openExport({
                filename: s+XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
                original: false,
                types: ['csv']
              })
        },
    pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getData()
    },
    cellClickEvent({row, column}) {
      const {
        href
      } = this.$router.resolve({path:  '/entity/'+row.oa_id_counterparty+'/home'})
      window.open(href, '_blank')
    },

    getData() {
      let self = this
      self.loading = true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      params.set('oaid', self.oaid)
      if (self.relation_type)
        params.set('relation_type', self.relation_type)
      httpManager("sc_influence", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          let page = response.data.page
          this.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    getOaid(){
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
        self.getData()
      })
    }
  },
  mounted() {
    this.tableColumn = [
      {type: 'seq', title: this.$t('supplychain.no'), width: 50},
      {title: this.$t('supplychain.company_name'), field: "counterparty_name", className: "click-cell-style"},
      {title: this.$t('supplychain.security_ticker'), field: "ticker_counterparty", className: "click-cell-style"},
      {title: this.$t('supplychain.supplier_influenced_weight'), className: "click-cell-style", field: "supplier_influenced_weight", formatter: ({ cellValue })=>
        {return cellValue != undefined & cellValue != null ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
      {title: this.$t('supplychain.customer_influenced_weight'), className: "click-cell-style", field: "customer_influenced_weight", formatter: ({ cellValue })=>
        {return cellValue != undefined & cellValue != null ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
    ]
    this.getOaid()
  },
  watch: {
    relation_type: function () {
      this.page.currentPage=1
      this.getData()
    },

  },
  created(){
  }
}
Vue.component("sc-influence", vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_influence.js